import React from 'react'
import { formatCurrency } from '@/utils'

interface FeeItem {
  name: string
  hourlyFee: number
}

interface IncomeBreakdownProps {
  jobIncome: number
  hourlyFees: number
  netIncome: number
  feeBreakdown: FeeItem[]
}

export function IncomeBreakdown({ jobIncome, hourlyFees, netIncome, feeBreakdown }: IncomeBreakdownProps) {
  return (
    <div className="text-sm">
      <div>Job Income: {formatCurrency(jobIncome)}/hour</div>
      <div className="mt-2">Equipment Fees:</div>
      {feeBreakdown.map((item, index) => (
        <div key={index} className="pl-4 text-xs">
          • {item.name}: -{formatCurrency(item.hourlyFee)}/hour
        </div>
      ))}
      <div className="font-bold mt-2">Net Income: {formatCurrency(netIncome)}/hour</div>
    </div>
  )
}
